import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IArchiveParams, IExamArchiveParams, IGetArchive, IGetArchives, IGetDownloadHistories, IGetExamArchive, IGetExamArchives } from '../models/archives.model';
import QueryString from 'qs';
import { IGetHeaderAlarmInquiries, IGetHeaderAlarmNotices, IHeaderAlarmNoticeParams } from '../models/headerAlarm.model';

const uri = '/mgmt/alarm';


interface IAlarmParams {
    memberCode: string;
    targetCode: number;
    alarmType: string;
}

export const getHeaderAlarmNotices = (params: IHeaderAlarmNoticeParams): AxiosPromise<IGetHeaderAlarmNotices> => {
    const qsParams = QueryString.stringify(params);
    return axios.get(`${uri}/board/notice?${qsParams}`);
}

export const getInquiries = (): AxiosPromise<IGetHeaderAlarmInquiries> => {
    return axios.get(uri);
}

export const getHeaderAlarmInquiries = (): AxiosPromise<IGetHeaderAlarmInquiries> => {
    return axios.get(`${uri}/parentsQna`);
}

export const createAlarm = (data: IAlarmParams): AxiosPromise => {
  return axios.post(`${uri}`, data);
};
